import React from 'react'
import Card from '@material-ui/core/Card';
import { Button, CardActionArea } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import Progress from 'react-progressbar';

function MyCard({header,imageUrl,message,buttonMessage}) {

  return (
    <div>
      <Card style={{backgroundColor:'#0E0E0E',padding:'10px',borderRadius:'10px',alignItems:'center',width:'200px',height:'350px',margin:'10px 0px'}}>
          <CardContent style={{textAlign:"center",padding:'0px'}}>
          <img style={{borderRadius:"10px",marginBottom:'10px'}} src={imageUrl} alt="card-images"/>
          <Typography style={{fontSize:'12px', color:'#CDCDCD',textAlign:'center'}} gutterBottom variant="h5" component="h2">
            {header}
          </Typography>
          <Typography style={{fontSize:'10px', color:'#CDCDCD',textAlign:'center',marginBottom:'20px'}} variant="body2" color="textSecondary" component="p">
            {message}
          </Typography>
        </CardContent>
        <Progress style={{backgroundColor:'black',borderRadius:'5px'}} color="#CDCDCD" completed={75} />
        <CardActionArea style={{textAlign:"center",paddingTop:'30px'}}>
          <Button 
          style={{
            borderRadius:'15px',
            fontSize:"0.8em",
            fontWeight:'700',
            letterSpacing:'2px',
            marginBottom:'10px',
            boxShadow:'0px 9px 14px rgba(255, 255, 255, 0.2)'}} 
            variant="contained" size="medium">{buttonMessage}
            </Button>
        </CardActionArea>
      </Card>
    </div>
  )
}

export default MyCard
